import React, { useState, useCallback } from 'react';
import { Box, Button, Paper, TextField, Typography } from '@mui/material';
import { Lock } from '@mui/icons-material';

const STORAGE_KEY = 'price_effects_unlocked';
const PASSWORD = 'elasticity';

export const isPriceEffectsUnlocked = () => {
  try {
    return sessionStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
};

const setUnlocked = (unlocked) => {
  try {
    if (unlocked) sessionStorage.setItem(STORAGE_KEY, '1');
    else sessionStorage.removeItem(STORAGE_KEY);
  } catch {}
};

const PriceEffectsGate = ({ children }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [unlocked, setUnlockedState] = useState(isPriceEffectsUnlocked);

  const handleSubmit = useCallback((e) => {
    e.preventDefault();
    setError('');
    if (password.trim().toLowerCase() === PASSWORD) {
      setUnlocked(true);
      setUnlockedState(true);
    } else {
      setError('Incorrect password');
    }
  }, [password]);

  if (unlocked) {
    return children;
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 400, p: 3 }}>
      <Paper elevation={2} sx={{ p: 3, maxWidth: 360, width: '100%' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
          <Lock sx={{ color: '#24336B', fontSize: 28 }} />
          <Typography variant="h6" sx={{ fontWeight: 700, color: '#24336B' }}>
            Price Effects
          </Typography>
        </Box>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Enter the project password to access.
        </Typography>
        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth
            type="password"
            label="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            error={!!error}
            helperText={error}
            autoFocus
            sx={{ mb: 2 }}
          />
          <Button type="submit" variant="contained" fullWidth sx={{ bgcolor: '#24336B' }}>
            Unlock
          </Button>
        </form>
      </Paper>
    </Box>
  );
};

export default PriceEffectsGate;
